import { createAction, createReducer } from '@reduxjs/toolkit'

export const receiveRates = createAction('ratesData/receive')

export const rateDataReducer = createReducer({}, (builder) => {
  builder.addCase(receiveRates, (state, action) => ({
    ...state,
    [action.payload.id]: action.payload.data,
  }))
})

export const selectRateData = (state) => state?.rateData || {}
